module.exports = __webpack_public_path__ + "static/sanfranciscodisplay-thin-webfont-639502ced011f40e86f80a74866126e3.woff";